"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(namespace) {
    const FETCH_REQUEST = `@sok/modules/project/list/${namespace}/FETCH_REQUEST`;
    const FETCH_SUCCESS = `@sok/modules/project/list/${namespace}/FETCH_SUCCESS`;
    const FETCH_FAILED = `@sok/modules/project/list/${namespace}/FETCH_FAILED`;
    const CLEAR = `@sok/modules/project/list/${namespace}/CLEAR`;
    return {
        FETCH_REQUEST,
        FETCH_SUCCESS,
        FETCH_FAILED,
        CLEAR
    };
}
exports.default = default_1;
//# sourceMappingURL=actionTypes.js.map